import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material"
import AngleRightIcon from "common/customIcons/angle_right"
import CommonLayout from "layouts/DashboardLayout"
import { Link, useNavigate, useParams } from "react-router-dom"
import AddBlogForm from "./add-blog-form"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from "react-redux"
import { useState } from "react"
import { useSelector } from "react-redux"

const AddBlogPage = () => {
    const navigate = useNavigate()
    const { blogId } = useParams()
    const dispatch = useDispatch()
    const [copyStatus, setCopyStatus] = useState('')
    const { currentBlog } = useSelector((state) => state.blogs)

    const handleCopyLink = () => {
        navigator.clipboard.writeText(`${currentBlog?.blog?.canonical}`)
            .then(() => {
                setCopyStatus('Copied!')
                setTimeout(() => setCopyStatus(''), 1000) // Clear message after 2 seconds
            })
            .catch(() => {
                setCopyStatus('Failed to copy')
                setTimeout(() => setCopyStatus(''), 1000) // Clear message after 2 seconds
            });
    }

    return (
        <CommonLayout>
            <AddBlogForm />
            {/* <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
                    <Box display="flex" alignItems="center" justifyContent={'space-between'} mb={2}>
                        <Box display="flex" alignItems="center" color='text.main' lineHeight={1}>
                            <span style={{ cursor: 'pointer', display: "flex", alignItems: "center" }} onClick={() => { navigate('/manages/blog') }}>
                                <AngleRightIcon fontSize="14px" />
                                <Typography variant='h6' fontWeight="semibold" ml={.75}>{blogId ? 'Blog' : 'Blog'}</Typography>
                            </span>
                        </Box>
                        {blogId && currentBlog?.blog?.canonical && (
                            <Box
                                display="flex"
                                sx={{ cursor: "pointer" }}
                                alignItems="center"
                                color="text.main"
                                lineHeight={1}
                                gap={2}
                                style={{ position: "relative" }}
                            >
                                <Tooltip title={copyStatus ? copyStatus : "Copy"} arrow>
                                    <IconButton
                                        size="small"
                                        onClick={handleCopyLink}
                                        sx={{ color: 'primary.main' }}
                                    >
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>

                                <Typography
                                    variant="body"
                                    component="a"
                                    href={`${currentBlog?.blog?.canonical}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ textDecoration: "none", color: "inherit" }}
                                    style={{
                                        borderRadius: "26px",
                                        color: "#0163FF",
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        border: "1px solid #0163FF",
                                        padding: "10px 16px",
                                    }}
                                >{`${currentBlog?.blog?.canonical}`}</Typography>

                            </Box>
                        )}
                    </Box>
                </Box>
            </Grid> */}
            {/* <Grid item xs={12}> */}
            {/* <AddBlogForm /> */}
            {/* </Grid> */}
        </CommonLayout>
    )
}
export default AddBlogPage